import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const visionMissionRoutes = [
	{
		key: "vision-mission-stats",
		exact: true,
		path: `${APP_PREFIX_PATH}/vision/statics`,
		component: React.lazy(() => import("views/app-views/vision/pages/VisionStatistics")),
	},
];
